<bootstrap-popup [id]="id" [title]="title" [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true" (closed)="onClose()">
	<div class="modal-body">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h3>Parc</h3>
			</div>
			<div class="panel-body formcontainer" *ngIf="parc">
				<form novalidate name="formParc" class="form-horizontal">
					<div class="control-group">
						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="pcode">Code&nbsp;*: </label>
								<div class="col-sm-7">
									<input type="text"
										name="pcode" id="pcode"
										class="form-control"
										placeholder="Entrer le nom du parc"
										[(ngModel)]="parc.code"
									/>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="pnom">Nom&nbsp;*: </label>
								<div class="col-sm-7">
									<input type="text"
										nom="pnom" id="pnom"
										class="form-control"
										placeholder="Entrer le nom du parc"
										[(ngModel)]="parc.description"
									/>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="address">Antenne&nbsp;*: </label>
								<div class="col-sm-4">
									<select
										name="pantenne" id="pantenne" required
										class="form-control"
										[ngModel]="parc.antenneId"
										(ngModelChange)="antenneId$.next($event)"
										>
										<option *ngFor="let antenne of antennes" [ngValue]="antenne.id">{{ antenne.nom }}</option>
									</select>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="platitude">Latitude&nbsp;: </label>
								<div class="col-sm-7">
									<input type="text"
										name="platitude" id="platitude"
										class="form-control"
										placeholder="Entrer la latitude du parc"
										[(ngModel)]="parc.latitude"
									/>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="plongitude">Longitude&nbsp;: </label>
								<div class="col-sm-7">
									<input type="text"
										name="plongitude" id="plongitude"
										class="form-control"
										placeholder="Entrer la longitude du parc"
										[(ngModel)]="parc.longitude"
									/>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">Technologie&nbsp;: </label>
								<div class="col-sm-7">
									<label *ngFor="let energie of energies" class="radio-inline">
										<input type="radio"
											[name]="'choixEnergie' + energie.id" [id]="'choixEnergie' + energie.id"
											[value]="energie.label"
											[(ngModel)]="parc.energie"
											(ngModelChange)="onEnergieChange($event)"
										/>
										{{ energie.label }}
									</label>
								</div>
							</div>
						</div>

						<div class="row" *ngIf="parc.energie === 'Solaire'">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">Type d'onduleurs : </label>
								<div class="col-sm-7">
									<label class="radio-inline"> 
										<input type="radio"
											name="choixCentralise" id="choixCentralise"
											[value]="false"
											[(ngModel)]="parc.typeOnduleur"
											/>
										Centralisés
									</label>
									<label class="radio-inline"> 
										<input type="radio"
											name="choixDecentralise" id="choixDecentralise"
											[value]="true"
											[(ngModel)]="parc.typeOnduleur"
											/>
										Décentralisés
									</label>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">Type de maintenance&nbsp;: </label>
								<div class="col-sm-7">
									<label *ngFor="let type of typesMaintenances" class="radio-inline">
										<input type="radio"
											[name]="'choixMaintenance' + type.id" [id]="'choixMaintenance' + type.id"
											[value]="type.label"
											[(ngModel)]="parc.type"
										/>
										{{ type.label }}
									</label>
								</div>
							</div>
						</div>
						
						<div class="row" *ngIf="parc.energie === 'Solaire'">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label" for="phyperviseur">Hyperviseur&nbsp;: </label>
								<div class="col-sm-7">
									<select
										name="phyperviseur" id="phyperviseur"
										class="form-control"
										[(ngModel)]="parc.hyperviseur"
										>
										<option *ngFor="let hyperviseur of hyperviseurOptions" [ngValue]="hyperviseur.value">
											{{ hyperviseur.label }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">Tarif négatif&nbsp;*? </label>
								<div class="col-sm-7">
									<label class="radio-inline">
										<input type="radio"
											name="choixTarifNegatif" id="choixTarifNegatif"
											[value]="true"
											[(ngModel)]="parc.tarifNegatif"
											>
										Oui
									</label>
									<label class="radio-inline">
										<input type="radio"
											name="choixPasTarifNegatif" id="choixPasTarifNegatif"
											[value]="false"
											[(ngModel)]="parc.tarifNegatif"
										>
										Non
									</label>
								</div>
							</div>
						</div>

						<div class="row" *ngIf="intervenantsInternesOptions">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">R&eacute;f&eacute;rent de parc&nbsp;:</label>
								<div class="col-sm-7">
									<filterable-select
										[id]="'responsable'"
										[inputClass]="'form-control'"
										[labelGetter]="intervenantLabelGetter"
										[list]="intervenantsInternesOptions"
										[selectedItem]="responsable$ | async"
										(selectedItemChange)="onResponsableChange($event)"
										>
									</filterable-select>
								</div>
								<ng-container *ngIf="(responsable$ | async) as responsable">
								    <div class="col-sm-7 col-sm-offset-5 details-responsable">
								        <span class="detail-item" *ngIf="responsable.email">
								            <span class="fa-solid fa-envelope"></span>
								            {{ responsable.email }}
								        </span>
								        <span class="detail-item" *ngIf="responsable.telephone">
								            <span class="fa-solid fa-phone"></span>
								            {{ responsable.telephone }}
								        </span>
								    </div>
								</ng-container>
							</div>
						</div>
						
						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-2 control-label"></label>
								<div class="col-sm-10">
									<div class="indicateurs-scroll">
										<div class="indicateur-block" *ngFor="let indicateur of indicateursAffiches">
										<div class="row">
											<div class="col-sm-3">
												<span class="indicateur-nom">
													<i [class]="indicateur.icon"></i>
													{{ indicateur.nom | titlecase }}
												</span>
											</div>
											<div class="col-sm-9">
									
												<div class="row indicateur-ligne" *ngIf="indicateur.surveillable">
													<label class="col-sm-3 indicateur-label" [for]="'indicSurveille' + indicateur.code">Surveill&eacute;</label>
													<div class="col-sm-6">
														<select class="form-control input-sm"
															[name]="'indicSurveille' + indicateur.code" [id]="'indicSurveille' + indicateur.code"
															[(ngModel)]="indicateur.surveille">
															<option value=""></option>
															<option value="1">Oui</option>
															<option value="0">Non</option>
														</select>
													</div>
												</div>
									
												<div class="row indicateur-ligne">
													<label class="col-sm-3 indicateur-label" [for]="'indicCouleur' + indicateur.code">Niveau</label>
													<div class="col-sm-6">
														<select class="form-control input-sm"
															[name]="'indicCouleur' + indicateur.code" [id]="'indicCouleur' + indicateur.code"
															[(ngModel)]="indicateur.couleur">
															<option *ngFor="let couleur of couleurLabels" [value]="couleur">
																{{ couleur }}
															</option>
														</select>
													</div>
												</div>
									
												<div class="row indicateur-ligne">
													<label class="col-sm-3 indicateur-label" [for]="'indicRegle' + indicateur.code">R&egrave;gle</label>
													<div class="col-sm-9">
														<textarea class="form-control input-sm" rows="2" maxlength="256"
															[name]="'indicRegle' + indicateur.code" [id]="'indicRegle' + indicateur.code"
															[(ngModel)]="indicateur.regle"></textarea>
													</div>
												</div>
									
											</div>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">Actif&nbsp;:</label>
								<div class="col-sm-7">
									<label class="radio-inline">
										<input type="radio"
											name="choixOui" id="choixOui"
											[value]="true"
											[(ngModel)]="parc.actif"
										/>
										Oui
									</label>
									<label class="radio-inline">
										<input type="radio"
											name="choixNon" id="choixNon"
											[value]="false"
											[(ngModel)]="parc.actif"
										/>
										Non
									</label>
								</div>
							</div>
						</div>

						<div class="row" *ngIf="allowsCacInput && parc.actif && candidatsCac">
							<div class="form-group col-sm-12">
								<label class="col-sm-5 control-label">CAC&nbsp;:</label>
								<div class="col-sm-7">
									<filterable-select
										[id]="'responsable'"
										[inputClass]="'form-control'"
										[labelGetter]="userLabelGetter"
										[list]="candidatsCac"
										[selectedItem]="cac$ | async"
										(selectedItemChange)="cac$.next($event)"
										>
									</filterable-select>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="form-group text-center">
								<button type="submit"
									class="btn btn-success"
									[disabled]="waitingForServer"
									(click)="onSaveRequested()"
									>
									{{ parc.id ? 'Modifier' : 'Ajouter' }}
								</button>
							</div>
						</div> 
					</div>
				</form>
			</div>
		</div>
	</div>
</bootstrap-popup>
